<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-full px-4">
      <CardSettings :actions="actions" back-route="/admin/course-group"  />
    </div>
    </div>
</template>
<script>
import CardSettings from "@/components/Cards/CardSettings.vue";
// import CardProfile from "@/components/Cards/CardProfile.vue";
import { API_BASE } from "@/const/uri";
export default {
  components: {
    CardSettings,
    // CardProfile,
  },
  data() {
    return {
      actions: API_BASE.courseGroup.get,
    };
  }
};
</script>
